/* eslint-disable react-hooks/exhaustive-deps */
import ButtonA from "../elements/ButtonA";
import { useState } from "react";
import { useEffect } from "react";
import styles from "./Presentation.module.css";

const Presentation = () => {
  const [text, setText] = useState("");
  const [loop, setLoop] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [delta, setDelta] = useState(100);

  const toRotate = ["Emerson Ávila", "Desenvolvedor FullStack"];
  const period = 100;

  useEffect(() => {
    let oClock = setInterval(() => {
      toType();
    }, delta);

    return () => {
      clearInterval(oClock);
    };
  }, [text]);

  const toType = () => {
    let i = loop % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setDelta(period);
      setLoop(loop + 1);
    }
  };

  return (
    <div className={styles.presentation} id="presentation">
      <h4>
        <strong>Bem-vindo ao meu Portfólio</strong>
      </h4>
      <h1>Olá, eu sou {text}</h1>
      <p>
        Sou um desenvolvedor Fullstack apaixonado por tecnologia e<br />
        inovação. Possuo habilidades para criar aplicativos web
        <br />
        dinâmicos e responsivos. Sempre atualizado com as últimas <br />
        tendências do setor, sou um profissional colaborativo, <br />
        comunicativo e disposto a aprender e compartilhar conhecimento com a
        equipe. <br />
        Estou entusiasmado em conseguir novas experiências e aprendizados,
        <br />
        também colaborar em novos projetos que me desafiem a evoluir cada vez
        mais.
      </p>

      <ButtonA
        text="Conecte-se comigo!!"
        link="https://github.com/EmersonAvilaDev"
      />
    </div>
  );
};

export default Presentation;
